export default "__VITE_ASSET__Df6JtN4J__"